module.exports = __webpack_public_path__ + "img/company_intro2.c3011104.jpg";